/**
 * Total da matrícula: disciplinas (específicas e serviços) + produtos vendidos
 * no step "Produtos". O valor de pagamento precisa fechar com este total.
 */
export function somarDisciplinas(disciplinas?: any[]): number {
  return (disciplinas || []).reduce((acc: number, item: any) => acc + (item?.valorFinal || 0), 0);
}

/**
 * Desconto e valor final de um produto a partir do valor cheio e do percentual.
 * O percentual é limitado a 0–100 e os valores ficam com 2 casas.
 */
export function valoresDoProduto(valor?: number, percDesconto?: number) {
  const valorBase = Number(valor) || 0;
  const perc = Math.min(Math.max(Number(percDesconto) || 0, 0), 100);
  const valorDesconto = Number(((valorBase * perc) / 100).toFixed(2));
  return {
    percDesconto: perc,
    valorDesconto,
    valorFinal: Number((valorBase - valorDesconto).toFixed(2)),
  };
}

/**
 * Só o que é efetivamente cobrado entra no total: produto trazido por uma
 * específica sai com 100% de desconto (valorFinal 0). O `valor` é o fallback
 * para os registros gravados antes da coluna de desconto existir.
 */
export function somarProdutos(produtos?: any[]): number {
  return (produtos || []).reduce(
    (acc: number, item: any) => acc + (item?.valorFinal ?? item?.valor ?? 0),
    0
  );
}

export function calcularTotalMatricula(disciplinas?: any[], produtos?: any[]): number {
  return somarDisciplinas(disciplinas) + somarProdutos(produtos);
}

/**
 * Parcela trocada por outra forma de pagamento (Financeiro > Controle
 * Pix/Transferência). Ela continua na matrícula como registro da troca, mas não
 * é pagamento: fica de fora do valor pago e, por consequência, do valor pendente.
 */
export function ehParcelaTrocada(parcela?: any): boolean {
  return parcela?.trocado === true;
}

/** Soma só as parcelas que valem como pagamento (ignora as trocadas). */
export function somarParcelasVigentes(parcelas?: any[]): number {
  return (parcelas || [])
    .filter((parcela) => !ehParcelaTrocada(parcela))
    .reduce((acc: number, parcela: any) => acc + (parcela?.valor || 0), 0);
}
